import { connect } from "react-redux";
import get from "lodash/get";
import { CompanyPreferredMailingAddressComponent } from "./CompanyPreferredMailingAddress";
import { getOrganizationInfo } from "../../../../store/selectors/appConfig";

const mapStateToProps = state => ({
  organisationAddressLine2: get(getOrganizationInfo(state), "addressDetails.addressLine2", ""),
  organisationAddressLine1: get(getOrganizationInfo(state), "addressDetails.addressLine1", ""),
  organisationEmirateCity: get(getOrganizationInfo(state), "addressDetails.emirateCity", ""),
  organisationCountry: get(getOrganizationInfo(state), "addressDetails.country", ""),
  organisationPoBox: get(getOrganizationInfo(state), "addressDetails.poBox", ""),
  premisesType: get(getOrganizationInfo(state), "typeOfPremises.premiseType", ""),
  otherPremisesType: get(getOrganizationInfo(state), "typeOfPremises.others", "")
});

export const CompanyPreferredMailingAddress = connect(mapStateToProps)(
  CompanyPreferredMailingAddressComponent
);
